import React from 'react';
import { IUser } from '../../types/damTypes';
import RecipeCorrectionPage from './RecipeCorrectionPage';

interface RecipeCorrectionModuleProps {
  assetId: string;
  currentUser: IUser | null;
  openedFromFullPage: boolean;
  readOnlySnapshot?: boolean;
  onClose: () => void;
  onApplied: (assetId: string) => void;
}

const RecipeCorrectionModule: React.FC<RecipeCorrectionModuleProps> = ({
  assetId,
  openedFromFullPage,
  readOnlySnapshot = false,
  onClose,
  onApplied,
}) => (
  <RecipeCorrectionPage
    assetId={assetId}
    openedFromFullPage={openedFromFullPage}
    readOnlySnapshot={readOnlySnapshot}
    onClose={onClose}
    onApplied={onApplied}
  />
);

export default RecipeCorrectionModule;
